// extracted by css-extract-rspack-plugin
export default {"buttonText":"Ntr33_YZD_4L7HP0"};